import { combineReducers } from "redux";
import {
  ADD_PRACTICE_REQUEST,
  CLEAR_SPECIALTY_PRACTICES,
  DELETE_PRACTICE_REQUEST,
  FETCH_PRACTICE_REQUEST,
  UPDATE_PRACTICE_REQUEST,
} from "../constants";
import { FETCH_DOCTOR_REQUEST } from "../../doctor/constants";
import { Action, IsFetching, OfficePracticeItems, SpacialtyPracticeItem } from "../types";
import { Action as DoctorAction } from "../../doctor/types";
import { getFailureActionType, getSuccessActionType } from "../../utils";

function items(state: OfficePracticeItems = {}, action: Action | DoctorAction): OfficePracticeItems {
  let officeId = 0;
  if ("data" in action) officeId = action.data?.officeId;
  let selectPractice = null;
  let newState = { ...state };

  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_REQUEST):
      action.payload.offices.forEach((office) => {
        return (newState[office.id] = office.officePractices);
      });
      return newState;

    case getSuccessActionType(ADD_PRACTICE_REQUEST):
      return { ...state, [officeId]: [...state[officeId], action.payload] };

    case DELETE_PRACTICE_REQUEST:
    case UPDATE_PRACTICE_REQUEST:
      selectPractice = state[officeId].map((practice) =>
        practice.id === action.data.practiceId
          ? {
              ...practice,
              isFetching: true,
            }
          : practice
      );
      return { ...state, [officeId]: selectPractice };

    case getSuccessActionType(DELETE_PRACTICE_REQUEST):
      selectPractice = state[officeId].filter((practice) => practice.id !== action.data.practiceId);
      return { ...state, [officeId]: selectPractice };

    case getSuccessActionType(UPDATE_PRACTICE_REQUEST):
      selectPractice = state[officeId].map((practice) =>
        practice.id === action.payload.id
          ? {
              ...action.payload,
              isFetching: false,
            }
          : practice
      );
      return { ...state, [officeId]: selectPractice };

    default:
      return state;
  }
}

function specialityPractice(state: SpacialtyPracticeItem = {}, action: Action): SpacialtyPracticeItem {
  let specialityId = 0;
  if ("data" in action) specialityId = action.data?.specialityId;

  switch (action.type) {
    case getSuccessActionType(FETCH_PRACTICE_REQUEST):
      return { ...state, [specialityId]: action.payload };
    case CLEAR_SPECIALTY_PRACTICES:
      return {};

    default:
      return state;
  }
}

function isFetching(state: IsFetching = {}, action: Action): IsFetching {
  let officeId = 0;
  if ("data" in action) officeId = action.data?.officeId;

  switch (action.type) {
    case ADD_PRACTICE_REQUEST:
      return { ...state, [officeId]: true };
    case getSuccessActionType(ADD_PRACTICE_REQUEST):
    case getFailureActionType(ADD_PRACTICE_REQUEST):
      return { ...state, [officeId]: false };

    default:
      return state;
  }
}

export const officePractices = combineReducers({ items, specialityPractice, isFetching });
